module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticStyle: {
      "font-family": "Calisto MT"
    }
  }, [_vm._v("The Secret Sign")]), _vm._v(" "), _c('ul', {
    staticStyle: {
      "font-family": "Calisto Mt",
      "margin-left": "-10px",
      "margin-top": "20px",
      "font-weight": "normal !important"
    }
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_000#toc_id_1"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_001#toc_id_2"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_002#toc_id_3"
    }
  }, [_vm._v("Copyright Information ©")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_003#id_Toc168649515"
    }
  }, [_vm._v("Glossary of RomanPlace Namesfor‘The Secret Sign’")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_004#id_Toc168649516"
    }
  }, [_vm._v("Chapter 1: The Search for Power")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_005#id_Toc168649517"
    }
  }, [_vm._v("Chapter 2: The Door Opens")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/index_split_006#id_Toc168649518"
    }
  }, [_vm._v("Chapter 3: Spectacle at the Arena")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_007#id_Toc168649519",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 4: Inside the House")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_008#id_Toc168649520",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 5: Trouble for Zara")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_009#id_Toc168649521",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 6: Master’s Response and a Crisis")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_010#id_Toc168649522",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 7: Escape from a Burning Rome")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_011#id_Toc168649523",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 8: On the High Seas")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_012#id_Toc168649524",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 9: A Shipwreck and a Surprise")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_013#id_Toc168649525",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 10: Island Adventure")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_014#id_Toc168649526",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 11: Peace—and Disaster")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_015#id_Toc168649527",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 12: Where is Rufus?")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_016#id_Toc168649528",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 13: Punishment—and New Arrivals")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_017#id_Toc168649529",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 14: The Big Freeze—and its Aftermath")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_018#id_Toc168649530",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 15: The Runaways")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_019#id_Toc168649531",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 16: On the way to Verulamium")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_020#id_Toc168649532",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 17: The Search")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_021#id_Toc168649533",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 18: A Surprising Discovery")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_022#id_Toc168649534",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 19: What became of Andreas?")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_023#id_Toc168649535",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 20: Dead or Alive?")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_024#id_Toc168649536",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 21: The Stowaway")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_025#id_Toc168649537",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 22: Flavia hears the News")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_026#id_Toc168649538",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 23: Andreas flees back to Rome")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_027#id_Toc168649539",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 24: Gaius returns home")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_028#id_Toc168649540",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 25: Andreas finds life hard")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_029#id_Toc168649541",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 26: Zara’s Quest")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_030#id_Toc168649542",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 27: Rebekah’s Story and a Shock")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_031#id_Toc168649543",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 28: Sailing Home")])]), _vm._v(" "), _c('li', [_c('span', {
    attrs: {
      "href": "#/index_split_032#id_Toc168649544",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Chapter 29: The End of it All—or New Beginnings")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-007288a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 60
// module chunks = 0